
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's04e610aea9079cc9': str`Misc`,
's091d3d07b5b3076f': str`OK`,
's0f10a738c0b28562': str`Trainer`,
's1100839df266863f': str`Media`,
's13a2ffafa077cae7': str`Plan`,
's1d318e9d0ccba86b': str`Chat`,
's2c4f75473cf240bd': str`Module`,
's2ceb11be2290bb1b': str`Cancel`,
's35d64e11653ce145': str`History:`,
's3a8fe3852a245245': str`Feed`,
's3e8c055d55a11be9': str`Break`,
's4a51df1e407b1bed': str`Select a plan`,
's4c7073d8560a507e': str`Name:`,
's57a13e6460ab0f25': str`Client`,
's617eb482d9f0d91f': str`Evaluation`,
's667ff2c6d2c2c111': str`New`,
's67749057edb2586b': str`Logout`,
's6b61eed684372fe6': str`Injury`,
's72f2a02e2a5a4ee3': str`Media`,
's749727eff9105c5a': str`Average trainings per week: ${0}`,
's74d7a739b6ab651d': str`History`,
's7bd83a7d74dc25bc': str`Repetitions`,
's86522b252b82ecff': str`App`,
's8b59b791fe19bd26': str`Duration`,
's8d0e201852b3dae3': str`Stretching`,
's96668830629e0dfc': str`Upload`,
's975202b2e0897162': str`Weight`,
's97a81a07637a5ca3': str`Hello ${0}`,
's9d8b8aa2b404c2c8': str`Settings`,
'sb1fcd93d997e5847': str`Series (separated by commas)`,
'sb7405e2aeaf0dcd5': str`Treinou hoje (Plano N, Treino X), incompleto`,
'sc05fdd8829793c61': str`Manage`,
'sc1a650d09d04351b': str`Notes`,
'sc7e79c5e5d64b991': str`Name of plan:`,
'sc8002664eec439d7': str`Cardio`,
'sc8a49056577f4e73': str`Todo`,
'sc8da3cc71de63832': str`Login`,
'sc8ed76b331047af8': str`Evaluation`,
'sd6cd4f2ac3777759': str`Weight:`,
'sdc12d4d35420eeb7': str`Comments`,
'se0d99ec33512a85a': str`Branding`,
'se65e4e6f3696e997': str`Training`,
'se84dbb9702babb0f': str`Upload video`,
'sef094143c1946626': str`Name of exercise`,
'sef74610caf0e1aad': str`Question`,
    };
  